import { CodeName, DateRange, LocalizedName, NumberRange } from '@heda/core-util';
import { MeasurementUnitReference } from 'app/mdm/terminology-lib/services/measurement-unit';

export class ObservationDefinition {
  public id?: number;
  public code?: string;
  public names?: LocalizedName;
  public period?: DateRange;
  public type?: CodeName;
  public category?: CodeName;
  public dataType?: CodeName;
  public dataOptions?: { [key: string]: any };
  public calculatedValue?: string;
  public bodySite?: string;
  public unitKind?: CodeName;
  public defaultUnit?: MeasurementUnitReference;
  public viewTemplate?: string;
  public properties?: {
    descriptionAllowed?: boolean;
    crosstabDisplayed?: boolean;
  };
  public identifiers?: ObservationDefinitionIdentifier[];
  public intervals?: ObservationDefinitionInterval[];
  public targets?: ObservationDefinitionTarget[];
  public references?: ObservationDefinitionReference[];
  public groups?: CodeName[];
  public referenceRangeStr?: string;
  public labObservation?: boolean;
}

export class ObservationDefinitionInterval {
  public id?: number;
  public definition?: CodeName;
  public usage?: CodeName;
  public interpretation?: CodeName;
  public range?: string;
  public names?: LocalizedName;
  public criteria?: ObservationDefinitionIntervalCriteria;
}

export class ObservationDefinitionIntervalCriteria {
  public age?: NumberRange;
  public gender?: string;
}

export class ObservationDefinitionTarget {
  public id?: number;
  public system?: string;
  public value?: string;
  public factor?: string;
}

export class ObservationDefinitionIdentifier {
  public id?: number;
  public system?: string;
  public value?: string;
  public descrition?: string;
}

export class ObservationDefinitionReference {
  public id?: number;
  public definitionReference?: ObservationDefinition;
  public validateIntervals?: boolean;
  public ordering?: number;
}

export class ObservationDefinitionMatchRequest {
  public val?: any;
  public refs?: { [key: string]: any };
  public criteriaValues?: { [key: string]: any };
  public usage?: string;
}

export class ObservationDefinitionCalculationResult {
  public val?: any;
  public refs?: { [key: string]: any };
  public intervals?: ObservationDefinitionInterval[];
}
